import { render, staticRenderFns } from "./FlacsDelegateRelation.vue?vue&type=template&id=3daaf527&scoped=true"
import script from "./FlacsDelegateRelation.vue?vue&type=script&lang=js"
export * from "./FlacsDelegateRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daaf527",
  null
  
)

export default component.exports